import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Modal from "react-modal";
Modal.setAppElement("#root");

const LabourCardUpdate = () => {
  const accessToken = localStorage.getItem("accessToken");
  const { id } = useParams();
  const location = useLocation();
  const labourCardToUpdate = location.state?.labourCardToUpdate;
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    navigate(`/employeedirectory/${id}`);
  };

  const labourCardDocuments = labourCardToUpdate.documents.filter(
    (doc) => doc.name === "Labour Card",
  );
  const labourCardDetailsArray = labourCardDocuments.map((doc) => ({
    id: doc.id,
    name: doc.name,
    url: doc.url,
    expiryDate: doc.expiryDate,
  }));

  const [documentState, setDocumentState] = useState({
    name: labourCardDetailsArray[0]?.name || "",
    id: labourCardDetailsArray[0]?.id || "",

    url: labourCardDetailsArray[0]?.url || "",
    expiryDate: labourCardDetailsArray[0]?.expiryDate || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDocumentState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdateDocument = () => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/employees/documents/update`;

    const fileInput = document.querySelector('input[type="file"]');
    const newFile = fileInput.files[0];

    const formData = new FormData();

    if (!newFile && documentState.url) {
      formData.append("documents[0][document_url]", documentState.url);
    }

    if (newFile) {
      formData.append("documents[0][file]", newFile, newFile.name);
    }

    formData.append("id", id);
    formData.append("documents[0][id]", documentState.id);
    formData.append("documents[0][name]", documentState.name);
    formData.append("documents[0][expiry_date]", documentState.expiryDate);

    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    };

    axios
      .post(apiUrl, formData, { headers })
      .then((response) => {
        setShowSuccessModal(true);
      })
      .catch((error) => console.error("Error:", error));
  };

  return (
    <div className="board__layout">
      <div className="section-header">
        <h1>Update Labour Card Details</h1>
      </div>

      <div className="form-item">
        <div className="form-rows">
          <div>
            <label htmlFor="file">Upload Labour Card Document</label>
            <input name="file" className="custom-file-upload" type="file" />
          </div>

          <div className="form-rows">
            <div>
              <label htmlFor="expiry_date">Expiry Date</label>
              <input
                type="date"
                name="expiry_date"
                placeholder="Expiry Date"
                value={documentState.expiryDate}
                onChange={(e) =>
                  setDocumentState({
                    ...documentState,
                    expiryDate: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div style={{ display: "none" }}>
            <label htmlFor="employee_info_id">Employee Information ID</label>
            <input
              type="number"
              name="employee_info_id"
              id="employee_info_id"
            />
            <label htmlFor="document_id">Document ID</label>
            <input
              type="number"
              name="document_id"
              id="document_id"
              value={documentState.id}
              onChange={(e) =>
                setDocumentState({ ...documentState, id: e.target.value })
              }
            />
          </div>
        </div>
      </div>

      <div className="form-btn-div" style={{ marginTop: "1rem" }}>
        <button
          type="button"
          className="btn-skip"
          onClick={() => navigate(`/dashboard`)}
        >
          Close
        </button>
        <button onClick={handleUpdateDocument} className="form-btn-submit">
          Update
        </button>
      </div>

      <Modal
        isOpen={showSuccessModal}
        onRequestClose={() => setShowSuccessModal(false)}
        contentLabel="Data Updated Successfully"
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <h5>Details Updated Successfully</h5>
        <button onClick={handleCloseModal}>OK</button>
      </Modal>
    </div>
  );
};

export default LabourCardUpdate;
